import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Deactivate subscription tier
 * Archives product in Stripe, marks inactive in database
 * Existing subscribers keep access until period end
 */
export const deactivateSubscriptionTierRpcContract = rpcContract({
  name: "deactivate-subscription-tier",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    success: v.boolean(),
    tierId: v.string(),
  }),
});

export type DeactivateSubscriptionTierParams = v.InferOutput<
  (typeof deactivateSubscriptionTierRpcContract)["paramsSchema"]
>;
export type DeactivateSubscriptionTierResult = v.InferOutput<
  (typeof deactivateSubscriptionTierRpcContract)["resultSchema"]
>;
